import Cookies from 'js-cookie';
import type { CookieConfig, TokenStorageStrategy } from '../tokenContracts';

const REFRESH_TOKEN_EXPIRY_DAYS = 30;

export class BrowserStrategy implements TokenStorageStrategy {
  setAccessToken(token: string, expiresAt: Date, config: CookieConfig): void {
    Cookies.set(config.accessTokenName, token, {
      domain: config.domain,
      path: config.path,
      secure: config.secure,
      sameSite: config.sameSite,
      expires: expiresAt
    });
  }

  getAccessToken(config: CookieConfig): string | undefined {
    return Cookies.get(config.accessTokenName);
  }

  setRefreshToken(token: string, config: CookieConfig): void {
    Cookies.set(config.refreshTokenName, token, {
      domain: config.domain,
      path: config.path,
      secure: config.secure,
      sameSite: config.sameSite,
      expires: REFRESH_TOKEN_EXPIRY_DAYS
    });
  }

  getRefreshToken(config: CookieConfig): string | undefined {
    return Cookies.get(config.refreshTokenName);
  }

  clearAll(config: CookieConfig): void {
    Cookies.remove(config.accessTokenName, { domain: config.domain, path: config.path });
    Cookies.remove(config.refreshTokenName, { domain: config.domain, path: config.path });
  }
}
